//#region src/verticals/referral/ReferralEvent.ts
var e = /* @__PURE__ */ function(e) {
	return e.LinkLanded = "referral.link.landed", e.CodeEntered = "referral.code.entered", e.AppResolveMatched = "referral.app.resolve_matched", e;
}({});
//#endregion
export { e as ReferralEvent };
